import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DragDropPrioritization }
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/components/DragDropPrioritization/DragDropPrioritization';
import { GoalItemLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/GoalItemLayout';
import { FDBodyText, FDTitleText } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

export const GoalPrioritizationOverride = buildFacetDesignOverride()
  .nameOverride('goals', {
    _component: () => DragDropPrioritization,
    _customProps: {
      layout: () => GoalItemLayout,
    },
  })
  .nameOverride('name', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    hidden: false, // This is here because BaseOverride sets it to hidden: true for title
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'medium',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textDisabled',
      align: 'center',
    },
  }, overrideReadOnly);
